import React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { EventType } from "pages/statuses/EventType";
import { BookingUtil } from "pages/booking/BookingUtil";
import { Chip } from "@material-ui/core";

const useStyles = makeStyles(() =>
    createStyles({
        bookingType: {
            padding: `7px`,
            color: `white`,
            fontSize: `large`
        },
    })
);

interface Props {
    // 予約情報
    booking: EventType;
}

/**
 * 溶媒種別表示コンポーネント
 * ダイアログのタイトルとして表示する溶媒種別を取得
 * @param props
 */
export const BookingTypeName: React.FC<Props> = (props) => {
    const { booking } = props;
    const classes = useStyles();

    return (
        <div>
            <Chip
                className={classes.bookingType}
                style={{
                    background: BookingUtil.getColorByBookingType(booking.bookingTypeId),
                }}
                size="medium"
                label={BookingUtil.getNameByBookingType(booking.bookingTypeId)}></Chip>
        </div>
    );
};
